// extracted by mini-css-extract-plugin
module.exports = {"container":"Project_container__3-QUr","content":"Project_content__1idZ9","nav":"Project_nav__Ffbqv"};